module.exports = __webpack_public_path__ + "public/images/icons/map-marker-alt-solid.svg";